import ReadMore from "../../../components/read-more";
import { Translate } from "react-translated";
import { Icon, Modal, List, Button, Tooltip } from "antd";
import React, { Component } from "react";
import F from "../../../Functions";
import moment from "moment";
import ShowReferrals from "../showReferrals";
import { get_label_from_value, TYPE_OF_CALL, VONSCHEDULER } from "../../../utils/Constants";
import OptimizedReadMore from "../components/OptimizedReadMore";

class DashModal extends Component {
  state = {
    showreferrals: false,
    currentReferralsIndex: null
  }

  getUserType = (val) => {
    if (val === VONSCHEDULER) {
      return "Review Follow-Up"
    } else
      return val
  }
  render() {
    const { notes, notes_loading, noteType } = this.props;


    let filterNotes = notes.filter(e => !noteType.length ? true : noteType.includes(e.notes_type))

    return (
      <Modal
        width={800}
        title={<Translate text={`Notes`} />}
        visible={this.props.showModal}
        onCancel={this.props.hideModal}
        footer={null}
      >
        <div className="formBox scrollable-modal-body">
          <List
            loading={notes_loading}
            itemLayout="horizontal"
            dataSource={filterNotes}
            // renderItem={(item) => (
            //   <List.Item>
            //     <List.Item.Meta
            //       title={item.user_name}
            //       description={<ReadMore>{item.note}</ReadMore>}
            //     />
            //     <div>
            //       <Icon
            //         type="clock-circle-o"
            //         style={{ marginRight: 5, marginLeft: 5 }}
            //       />
            //       {moment(item.created_on).format("MM/DD/YYYY hh:mmA")}
            //     </div>
            //   </List.Item>
            // )}
            renderItem={(item, index) => {
              const notesData = F.getActualNotesAndPostFixData(item.note);

              const hasNote =
                notesData.actualNotes &&
                notesData.actualNotes.trim().length > 0;

              const actionContainerStyle = !hasNote ? { margin: 0 } : {};

              return (
                <List.Item>
                  <div style={{ width: "100%" }} id="notesContainer">
                    <div>
                      <div className="internal-btn-container  paddinng-bottom-10">
                        <div className="internal-btn-container">
                          <Tooltip
                            placement="top"
                            title={item.user_name.length > 18 ? item.user_name : null}
                          >
                            <span
                              className="text-12 text-color-456DAC font-weight-700 notes-text-span"
                              style={{
                                paddingRight: "35px",
                                maxWidth: "180px",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor:'pointer'
                              }}
                            >
                              {item.user_name}
                            </span>
                          </Tooltip>

                          <span className="text-12 text-color-456DAC font-weight-700">
                            {moment(item.created_on).format("MM/DD/YYYY hh:mmA")}
                          </span>
                        </div>

                        {/* internal heading */}
                        <div>
                          <button className="internal-btn text-12">
                            {this.getUserType(item.notes_type)}
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* 1 */}
                    {item.type_of_call &&
                      item.type_of_call.length > 0 && (
                        <div className="notes-second-container padding-top-10  ">
                          <div className="">
                            <span className="text-12 font-weight-600 notes-text-span ">
                              Type of Call:
                            </span>
                          </div>
                          <div className="text-12">
                            {" "}
                            {TYPE_OF_CALL[`${item.type_of_call}`]}
                          </div>
                        </div>
                      )}
                    {/* 2 */}
                    {item.sub_type_of_call &&
                      item.sub_type_of_call.length > 0 && (
                        <div className="notes-second-container padding-top-10  ">
                          <div className="">
                            <span className="text-12 font-weight-600 notes-text-span ">
                              Sub Type of call:
                            </span>
                          </div>
                          <div className="text-12">
                            {get_label_from_value(
                              item.sub_type_of_call,
                              "label",
                              item.type_of_call
                            )}
                          </div>
                        </div>
                      )}
                    {/* 3 */}
                    {item.action && (
                      <div className="notes-second-container padding-top-10  ">
                        <div className="">
                          <span className="text-12 font-weight-600 notes-text-span ">
                            Action:
                          </span>
                        </div>
                        <div className="text-12">{item.action}</div>
                      </div>
                    )}
                    {/* 4 */}
                    {hasNote && (
                      <div>
                        <div className="notes-second-container padding-top-10  ">
                          <div className="">
                            <span className="text-12 font-weight-600 notes-text-span ">
                              Notes:
                            </span>
                          </div>
                          <div className="text-12" style={{ width: "70%" }}>
                            {/* <ReadMore viewTag> */}
                            <OptimizedReadMore>
                              {F.stripHtml(F.getActualNotesSubType(
                                notesData.actualNotes,
                                item.type_of_call
                              ))}
                            </OptimizedReadMore>
                            {/* </ReadMore> */}
                          </div>
                        </div>
                        {item.referrals.length !== 0 && <Button onClick={() => this.setState({ showreferrals: true, currentReferralsIndex: index })}>Show Referrals</Button>}
                        {item.referrals.length !== 0 && this.state.showreferrals && <ShowReferrals visible={this.state.showreferrals} handleCancel={() => this.setState({ showreferrals: false })} data={filterNotes[this.state.currentReferralsIndex].referrals} />}
                      </div>
                    )}
                  </div>
                </List.Item>
              );
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/notes-modal.js